module.exports = __webpack_public_path__ + "static/media/Jonas_A0_Rectangle_52_pattern@2x_cut.094bc70c.png";